<template>
  <div>
    <transition name="slide" enter-active-class="slideInDown" leave-active-class="slideOutUp">
      <div v-if="inCall" class="c-box-call is-success active">
        <div class="c-box-call__inner">
          <div class="row">
            <div class="col-md-6 c-box-call__left">
              <div class="ring-container">
                <div class="ringring"></div>
                <div class="circle"></div>
              </div>
              <div class="c-transcript" v-if="transcript">
                <div class="c-transcript__content">{{ transcript }}</div>
              </div>
            </div>
            <div class="col-md-6 c-box-call__right">
              <div class="c-call-widget" :class="statusIcon">
                <div class="c-call-widget__circle"><i :class="directionIcon"></i></div>
                <div class="c-call-widget__text">{{ $t(direction) }}</div>
              </div>
              <div class="c-call-line"></div>
              <div class="c-call-name">
                <div class="c-call-name__row">
                  <i class="icon12-user-gadient"></i>
                  <b>
                    <a :href="contact&& contact.customer?`/#/customer/${contact.customer._id}`:null">
                      {{ displayedContactName }} (
                      <phone-display :phone="number"></phone-display>
                      )
                    </a>
                  </b>
                  <a v-if="!contact || !contact.customer" href="javascript:;" class="btn btn-link btn-xs"
                     @click="$bus.$emit('createCustomer', number)">
                    <i class="icon12-add-white icon-left"></i>
                    <i class="fa fa-plus"></i>
                    {{ $t('createContact') }}
                  </a>
                </div>
                <div v-if="contact && contact.customer" class="c-call-name__row">
                  <i class="icon12-company-gadient"></i><span>{{ contact.customer.name }}</span>
                </div>
              </div>
              <div v-if="callStatus==='accepted'" class="c-call-line"></div>
              <div v-if="callStatus==='accepted'" class="c-box-pad">
                <button @click="mute" :class="isMuted?'disabled':''"><i class="icon24-mute-primary"></i></button>
                <button @click="hold" class="text-primary" :class="isOnHold?'disabled':''" data-toggle="tooltip"
                        data-placement="top" :title="isOnHold?$t('unHold'):$t('hold')">
                  <i class="fa fa-pause"></i>
                </button>
                <button @click="transfer"><i class="icon32-repeat-primary"></i></button>
                <div class="dropdown">
                  <button type="button" @click="showKeypad=!showKeypad"><i class="icon24-dial-primary"></i></button>
                  <div class="dropdown-menu is-custom dropdown-menu-right" :class="showKeypad?'show':null">
                    <div class="dropdown-menu__inner">
                      <div class="c-call-screen">
                        <div class="c-call-screen__row">
                          <div class="c-call-number">
                            <input v-model="keypadInput" class="c-call-number__text">
                            <button @click="backKeypad" class="c-call-number__back"><i class="fa fa-times"></i></button>
                          </div>
                        </div>
                        <div class="c-call-screen__row">
                          <div class="c-push-number">
                            <ul class="clearfix">
                              <li>
                                <button @click="keypadInput+='1'">1</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='2'">2</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='3'">3</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='4'">4</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='5'">5</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='6'">6</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='7'">7</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='8'">8</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='9'">9</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='*'">*</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='0'">0</button>
                              </li>
                              <li>
                                <button @click="keypadInput+='#'">#</button>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div v-if="keypadInput" class="c-call-screen__row">
                          <button @click="sendKeypad" class="btn btn-primary btn-block btn-lg" type="button">Ok</button>
                        </div>
                      </div>
                      <!-- c-call-screen-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-call-line"></div>
              <div class="c-box-call__time">
                <span v-if="isOnHold">{{ $t('onHold') }}</span>
                <span v-else-if="isMuted">{{ $t('microphoneMuted') }}</span>
                <span v-else>{{ $t(callStatus) }}</span>
                <span v-if="callStatus==='accepted'"> - {{ duration | callDuration }}</span>
              </div>
              <div class="c-box-call__ok" v-if="direction==='incoming' && ['new'].includes(callStatus)">
                <button @click="answerCall" class="btn btn-success btn-sm is-border-circle" type="button">
                  <i class="icon12-phone-white icon-left"></i>{{ $t('answer') }}
                </button>
              </div>
              <div class="c-box-call__end" v-if="callStatus!=='ended'">
                <button v-if="callStatus==='ending'" class="btn btn-danger" type="button">
                  <b-spinner></b-spinner>
                </button>
                <button v-else @click="endCall" class="btn btn-danger" type="button">
                  <i class="icon16-call-end-white"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <b-modal v-model="showTransferForm" :title="$t('transfer')" @ok="transferCall" ok-only :no-close-on-backdrop="true" :no-enforce-focus="true">
      <b-form-group :label="$t('transferNumber')">
        <b-form-input v-model="transferNumber" :placeholder="$t('transferNumber')"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import JsSIP from 'jssip';
import console from 'console';
import {Howl} from 'howler';
import md5 from 'md5';
import _ from 'lodash';
import $ from 'jquery';
import PhoneDisplay from "./PhoneDisplay";
import getUserMedia from 'get-user-media-promise';

export default {
  components: {PhoneDisplay},
  data: function () {
    return {
      callId: null,
      inCall: false,
      stream: null,
      showTransferForm: false,
      direction: null,
      duration: 0,
      durationTimer: null,
      number: '',
      transferNumber: '',
      name: null,
      contact: null,
      phoneStatus: 'pending',
      callStatus: null,
      phone: null,
      call: null,
      ring: null,
      isMuted: false,
      isOnHold: false,
      showKeypad: false,
      keypadInput: '',
      callOptions: {
        mediaConstraints: {
          audio: true,
          video: this.$store.state.videoCallEnabled
        },
        pcConfig: {
          iceTransportPolicy: 'relay',
          iceServers: [
            {
              urls: [
                `turn:${this.$store.state.user.client.host.ip}`
              ],
              username: "callio",
              credential: "collia"
            }
          ],
        }
      },
      recognition: null,
      transcripts: [],
      transcript: null
    }
  },
  computed: {
    directionIcon() {
      if (this.direction === 'incoming') {
        return 'icon12-call-callin-white';
      }
      return 'icon12-call-callout-white';
    },
    statusIcon() {
      if (!this.callStatus) {
        return 'is-warning';
      }
      if (this.callStatus === 'ended') {
        return 'is-danger';
      }
      if (this.callStatus === 'accepted') {
        return 'is-success';
      }
      return 'is-warning';
    },
    displayedContactName() {
      if (this.contact && this.contact.name) {
        return this.contact.name
      } else if (this.direction === 'incoming' && this.name) {
        return this.name
      }
      return this.$t('unknown');
    }
  },
  watch: {
    inCall(val) {
      if (val) {
        $('body').addClass('active-call');
      } else {
        $('body').removeClass('active-call');
      }
    }
  },
  methods: {
    makeCall(number, campaignId) {
      if (!this.phone || this.$store.state.phoneStatus !== 'connected') {
        this.$swal({
          text: this.$t('phoneDisconnected'),
          icon: 'warning'
        });
        return;
      }
      if (number) {
        this.number = number.replace(/\D/g, '');
      } else {
        this.number = '';
      }
      if (this.number && this.number !== '') {
        this.number = this.number.trim();
        if (!this.$store.state.inCall) {
          if (this.recognition) {
            try {
              this.recognition.start();
            } catch (e) {
              console.log(e);
            }
          }
          this.inCall = true;
          this.callStatus = 'new';
          this.callOptions.extraHeaders = ['X-CallerNumber: ' + this.$store.state.callerNumber];
          if (campaignId) {
            this.callOptions.extraHeaders = ['X-CampaignId: ' + campaignId];
          }
          this.phone.call(this.number, this.callOptions);
          getUserMedia({audio: true, video: false}).then(() => {
            this.call.connection.addEventListener("addstream", (e) => {
              console.log("Media connected!");
              const remoteAudio = document.createElement('audio');
              remoteAudio.setAttribute('id', 'callAudio');
              remoteAudio.srcObject = e.stream;
              remoteAudio.play();
            });
          }).catch((err) => {
            console.log(err);
          });
          this.loadContact();
        } else {
          this.$swal({
            text: this.$t('otherCallInProgress'),
            icon: 'warning'
          });
        }
      } else {
        this.$swal({
          text: this.$t('phoneNumberRequired'),
          icon: 'warning'
        });
      }
    },
    endCall() {
      if (this.call) {
        try {
          this.call.terminate();
          this.callStatus = 'ending';
        } catch (e) {
          console.log(e);
        }
        console.log(`Call terminated`);
      } else {
        console.log(`Call session not found to terminated`);
      }
      this.name = null;
    },
    answerCall() {
      if (this.call) {
        if (this.ring)
          this.ring.stop();
        this.callStatus = 'progress';
        this.call.answer(this.callOptions);
      }
    },
    mute() {
      if (this.call) {
        console.log(this.call.isMuted());
        if (this.call.isMuted().audio) {
          this.call.unmute();
        } else {
          this.call.mute();
        }
      } else {
        this.isMuted = false;
      }
    },
    hold() {
      if (this.call) {
        if (this.call.isOnHold().local || this.call.isOnHold().remote) {
          this.call.unhold();
        } else {
          this.call.hold();
        }
      } else {
        this.isOnHold = false;
      }
    },
    transfer() {
      if (this.call) {
        this.showTransferForm = true;
      }
    },
    transferCall() {
      if (this.call && this.transferNumber && this.transferNumber.trim() !== '') {
        this.call.refer(this.transferNumber.trim());
      }
      this.transferNumber = '';
      this.showTransferForm = false;
    },
    sendKeypad() {
      if (this.keypadInput.length && this.call) {
        this.call.sendDTMF(this.keypadInput, {
          'transportType': 'RFC2833'
        });
        this.keypadInput = '';
        this.showKeypad = false;
      }
    },
    backKeypad() {
      if (this.keypadInput.length) {
        this.keypadInput = this.keypadInput.slice(0, -1);
      }
    },
    loadContact() {
      this.contact = null;
      if (this.number && this.number.length > 6) {
        let keyword = this.number;
        let countryPrefix = this.$store.state.user.client.country.phonePrefix;
        let prefixRegex = new RegExp(`^(\\+${countryPrefix}|00${countryPrefix}|${countryPrefix}|0)([0-9]+)$`);
        if (prefixRegex.test(keyword)) {
          keyword = keyword.replace(prefixRegex, '$2')
        }
        this.$bgService.get('/contact', {
          params: {
            phone: keyword,
            page: 1,
            pageSize: 1
          }
        }).then(response => {
          if (response.data.docs.length > 0) {
            this.contact = response.data.docs[0];
          } else {
            this.contact = null;
          }
        }).catch(() => {
          this.contact = null;
        });
      } else {
        this.contact = null;
      }
    },
    submitTranscript() {
      if (this.recognition) {
        try {
          this.recognition.stop();
        } catch (e) {
          console.log(e);
        }
      }
      if (this.transcripts.length) {
        this.$bgService.post('/call/transcripts', {
          callId: this.callId,
          transcripts: this.transcripts
        }).then(() => {
          this.transcript = null;
          this.transcripts = [];
        });
      } else {
        this.transcript = null;
        this.transcripts = [];
      }
    },
    connect() {
      if (this.phone) {
        return;
      }
      this.$store.commit('phoneStatus', 'connecting');
      this.phone = new JsSIP.UA({
        sockets: [new JsSIP.WebSocketInterface('wss://' + this.$store.state.user.client.domain + ':7443')],
        uri: 'sip:' + this.$store.state.user.ext + '@' + this.$store.state.user.client.domain,
        realm: this.$store.state.user.client.domain,
        ha1: md5(this.$store.state.user.ext + ':' + this.$store.state.user.client.domain + ':' + this.$store.state.user.extPassword),
        contact_uri: 'sip:' + this.$store.state.user.ext + '@' + this.$store.state.user.client.domain + ';transport=ws',
      });
      this.phone.on('registered', (e) => {
        this.$store.commit('phoneStatus', 'connected');
        console.log('Phone registered');
        console.log(e);
      });
      this.phone.on('disconnected', (e) => {
        this.$store.commit('phoneStatus', 'disconnected');
        console.log('Phone disconnected');
        console.log(e);
      });
      this.phone.start();
      this.phone.on("newRTCSession", (data) => {
        if (this.call || (this.$store.state.phoneIdle && this.call.direction === "incoming")) {
          data.session.terminate();
          return;
        }
        this.call = data.session;
        console.log(data);
        this.inCall = true;
        this.$store.state.inCall = true;
        this.direction = this.call.direction;
        this.callStatus = 'new';
        this.isMuted = false;
        this.isOnHold = false;
        if (this.call.direction === "incoming") {
          this.number = data.request.from.uri.user;
          if (data.request.from.uri.user !== data.request.from.display_name) {
            this.name = data.request.from.display_name;
          } else {
            this.name = null;
          }
          this.loadContact();
          this.$bus.$emit('titleNotification', this.$t('incomingCallNotification', [this.number]));
          this.$notification.show(this.$t('incomingCall'), {
            body: this.$t('incomingCallNotification', [this.number]),
            vibrate: true
          }, {});
          if (!this.ring)
            this.ring = new Howl({
              src: ['/sound/phone-ring.mp3'],
              loop: true
            });
          this.ring.play();
        }
        this.call.on("icecandidate", (e) => {
          setTimeout(() => {
            e.ready();
          }, 5000);
        });
        this.call.on('peerconnection', (data) => {
          data.peerconnection.onaddstream = (e) => {
            getUserMedia({audio: true, video: this.$store.state.videoCallEnabled}).then(() => {
              const remoteAudio = document.createElement('audio');
              remoteAudio.setAttribute('id', 'callAudio');
              remoteAudio.srcObject = e.stream;
              remoteAudio.play();
            }).catch((err) => {
              console.log(err);
            });
            console.log("Media connected!");
          };
        });
        this.call.on("progress", () => {
          console.log('progress');
          console.log(this.call.id.replace(this.call._from_tag, ''));
          if (this.call.direction !== "incoming") {
            this.callStatus = 'progress';
          }
          callStatusUpdated();
        });

        let callStatusUpdated = () => {
          this.callId = this.call.id.replace(this.call._from_tag, '').replace(this.call._to_tag, '');
          this.$bus.$emit("callStatusUpdated", this.number, this.callId, this.callStatus);
        };
        callStatusUpdated();

        this.call.on('accepted', () => {
          console.log('accepted');
          if (this.call.direction !== "incoming") {
            this.callStatus = 'progress';
          }
          callStatusUpdated();
        });

        this.call.on('confirmed', () => {
          console.log('confirmed');
          this.callStatus = 'accepted';
          this.$bus.$emit('titleNotificationOff');
          if (this.durationTimer) {
            clearInterval(this.durationTimer);
          }
          this.duration = 0;
          this.durationTimer = setInterval(() => {
            this.duration++;
          }, 1000);
          if (this.call.direction === "incoming") {
            this.$bus.$emit("newIssueManually");
          }
          callStatusUpdated();
          if (this.ring)
            this.ring.stop();
          if (this.$store.state.user.client.callConnectPromptSounds) {
            let audio = new Howl({
              src: ['/sound/call-start.mp3'],
            });
            audio.play();
          }
        });

        let ended = _.debounce((e) => {
          console.log('ended', e);
          this.callStatus = 'ended';
          setTimeout(() => {
            if (!this.$store.state.inCall) {
              this.inCall = false;
            }
          }, 1000);
          this.$store.state.inCall = false;
          this.$bus.$emit('titleNotificationOff');
          this.showKeypad = false;
          this.keypadInput = '';
          this.submitTranscript();
          callStatusUpdated();
          this.call = null;
          if (this.ring) {
            this.ring.stop();
          }
          this.$bus.$emit('eliminateNum');
          //play sound end call
          if (this.$store.state.user.client.callConnectPromptSounds) {
            let audio = new Howl({
              src: ['/sound/call-end.mp3'],
            });
            audio.play();
          }
          $('#callAudio').remove();
        }, 200, {leading: true, trailing: false});
        this.call.on('ended', ended);
        this.call.on('failed', ended);

        this.call.on('hold', () => {
          this.isOnHold = true
        });
        this.call.on('unhold', () => {
          this.isOnHold = false
        });
        this.call.on('muted', () => {
          this.isMuted = true
        });
        this.call.on('unmuted', () => {
          this.isMuted = false
        });
      });
    },
    disconnect() {
      this.phone.unregister();
    }
  },
  mounted() {
    this.connect();
    try {
      if ("speechSynthesis" in window) {
        let SpeechRecognition = window.speechRecognition || window.webkitSpeechRecognition;
        this.recognition = new SpeechRecognition();
        this.recognition.lang = 'vi-VN';
        this.recognition.continuous = true;
        this.recognition.interimResults = false;

        this.recognition.onend = () => {
          if (['progress', 'new', 'accepted'].includes(this.callStatus)) {
            try {
              this.recognition.start();
            } catch (e) {
              console.log(e);
            }
          }
        };
        this.recognition.onresult = (event) => {
          for (let result of event.results) {
            if (!this.transcripts.includes(result[0].transcript)) {
              this.transcript = result[0].transcript;
              this.transcripts.push(result[0].transcript);
            }
          }
        };
      }
    } catch (e) {
      console.log('No voice rec');
    }
    this.$bus.$on('connectPhone', this.connect);
    this.$bus.$on('disconnectPhone', this.disconnect);
    this.$bus.$on('makeCall', this.makeCall);
    this.$bus.$on('answerCall', this.answerCall);
    this.$bus.$on('endCall', this.endCall);
    this.$bus.$on('relloadContactPhone', this.loadContact);
  },
  beforeDestroy() {
    this.$bus.$off('connectPhone');
    this.$bus.$off('disconnectPhone');
    this.$bus.$off('makeCall');
    this.$bus.$off('answerCall');
    this.$bus.$off('endCall');
    this.$bus.$off('relloadContactPhone');
    this.endCall();
  }
}
</script>